import React, { useContext, useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { SessionContext, AppContext } from 'contexts'
import { initialPage } from 'utilities/pagination'
import { createExcel } from 'utilities/excel'
import { columns, filters, handlers } from 'models/reportList'
import { Center, Link, Section, Table } from 'components/core'
import Page from 'components/Page'
import ReportDrawer from 'views/ReportDrawer'
import { MdFileUpload } from 'react-icons/md'

export default () => {
  const { formatMessage: message } = useIntl()
  const session = useContext(SessionContext)
  const app = useContext(AppContext)
  const [locations, setLocations] = useState([])
  const [state, setState] = useState([])
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState({})
  const [filterValues, setFilterValues] = useState([])
  const [pagination, setPagination] = useState(initialPage())
  const { handleLoad, handleExport } = handlers({
    session,
    app,
    message,
    setState,
    setFilterValues,
    setPagination,
    setLocations,
  })

  useEffect(() => {
    handleLoad()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOpen = (item) => {
    setValue(item)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setValue({})
  }

  return (
    <Page
      title="report.title.stockList"
      navId="reportStockList"
      action={
        <Center>
          <Link
            mr={3}
            icon={<MdFileUpload />}
            text="btn.export"
            onClick={() => handleExport({ filterValues, createExcel })}
          />
        </Center>
      }
    >
      <Section>
        <Table
          columns={columns({
            filterValues,
            action: { handleOpen, handleLoad },
          })}
          rows={state}
          filters={filters({ message, data: { locations } })}
          filterValues={filterValues}
          pagination={pagination}
          onChange={handleLoad}
        />
      </Section>
      <ReportDrawer value={value} open={open} action={{ handleClose }} />
    </Page>
  )
}
